import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseOk, setResponseOk] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    try {
      const response = await fetch("https://core-bankers-backend.vercel.app/contact-us", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setResponseOk(true);
        setResponseMessage("Message sent successfully. We typically respond within 2 hours.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setResponseOk(false);
        setResponseMessage(result.message || "Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      setResponseOk(false);
      setResponseMessage("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-inner cb-rise">
          <span className="cb-section-label">Contact</span>
          <h1>Speak with Core Bankers</h1>
          <p>Questions on eligibility, documentation, or lender options — reach the team directly.</p>
        </div>
      </section>

      <section className="contact-layout cb-container">
        <div className="contact-form">
          <h2>Send a message</h2>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Name"
              name="name"
              variant="outlined"
              fullWidth
              className="input-field"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              className="input-field"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <TextField
              label="Message"
              name="message"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              className="input-field"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <Button type="submit" variant="contained" size="large" className="send-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </Button>
            {responseMessage && (
              <p className={`form-response ${responseOk ? "is-success" : "is-error"}`}>
                {responseMessage}
              </p>
            )}
          </form>
        </div>

        <aside className="contact-info">
          <h2>Office</h2>
          <p>
            Core Bankers, VedhaNirvana Pvt Ltd
            <br />
            8th Floor, South Towers, KRM Plaza
            <br />
            Harrington Road, Chetpet
            <br />
            Chennai, Tamil Nadu - 600031
          </p>
          <p className="contact-meta">
            <strong>Phone</strong>
            <br />
            +91 86394 15052
          </p>
          <p className="contact-meta">
            <strong>Email</strong>
            <br />
            Manager@CoreBankers.in
          </p>
        </aside>
      </section>
    </main>
  );
};

export default ContactUs;
